import React, { useMemo } from 'react';
import ChatterBox from '../../../components/ux/ChatterBox';
import { channelMessage } from '../../../common';
import { buildIssueNoteActions } from './issueNoteActions';
import { mergeIssueNoteMessages } from './issueNoteMessages';

const { normalizeChannelMessage } = channelMessage;

const IssueNotes = ({
   channel,
   optimisticMessages = [],
   loading,
   error,
   unavailable,
   onRetry,
   formatDateTime,
   currentUser,
   draft,
   onDraftChange,
   onSend,
   onRetryMessage,
   onRemoveMessage,
   submitting,
   submitError,
   readOnly,
   readOnlyMessage,
   onDeleteNote
}) => {
   const messages = useMemo(() => {
      const persisted = ((channel && channel.frames) || []).map(normalizeChannelMessage);
      return mergeIssueNoteMessages(persisted, optimisticMessages);
   }, [channel, optimisticMessages]);

   const getMessageActions = (message) => buildIssueNoteActions({
      isIssueClosed: readOnly,
      message,
      currentUser,
      onDeleteNote
   });

   return (
      <ChatterBox
         messages={messages}
         currentUser={currentUser}
         draft={draft}
         onDraftChange={onDraftChange}
         onSend={onSend}
         onRetryMessage={onRetryMessage}
         onRemoveMessage={onRemoveMessage}
         submitting={submitting}
         error={submitError}
         readOnly={readOnly}
         readOnlyMessage={readOnlyMessage}
         loading={loading}
         loadingError={error}
         unavailable={unavailable}
         onRetryLoad={onRetry}
         formatDateTime={formatDateTime}
         getMessageActions={getMessageActions}
      />
   );
};

export default IssueNotes;
